import { useEffect, useState } from "react";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import {
  CLEAR_BASKET_URL,
  GET_CONFIRMATION,
  GET_CONFIRMATION_DOCUMENT,
  GET_CONFIRMATION_TICKETS,
} from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import { ConfirmationData } from "../../models/ConfirmationData";
import convertToPdf from "../../../utils/convertToPdf";
import { post } from "../../api";
import { useLocation } from "react-router";
import qs from "qs";

export default function useConfirmationData() {
  const { get } = useApiRequest();
  const location = useLocation();
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [billKey, setBillKey] = useState("");
  const [confirmationData, setConfirmationData] = useState({
    email: "",
    containsInvoice: false,
    containsTickets: false,
  } as ConfirmationData);

  const handleClearBasket = async () => {
    await post(CLEAR_BASKET_URL(facilityIds));
  };

  useEffect(() => {
    handleClearBasket();
    const url_string = sessionStorage.getItem("parentPageUrl");
    if (url_string !== null) {
      var url = new URL(url_string);
      var k = url.searchParams.get("k");
      setBillKey(k as string);
    }
    if (url_string === null) {
      const billKeyParam = qs.parse(location.search.slice(1)).k as string;
      setBillKey(billKeyParam);
    }

    //eslint-disable-next-line
  }, []);

  const getConfirmationData = async () => {
    setLoading(true);
    const params = {
      facilityIds: `0,${facilityIds}`,
      billKey: billKey,
    };
    const { result, isError } = await get(GET_CONFIRMATION(params));
    if (!isError) {
      setConfirmationData(result);
    }
    setLoading(false);
  };

  useEffect(() => {
    getConfirmationData();
    //eslint-disable-next-line
  }, [billKey, facilityIds]);

  const getConfirmationDocument = async () => {
    setLoading(true);
    const params = {
      facilityIds: `0,${facilityIds}`,
      billKey: billKey,
    };
    const { result, isError } = await get(GET_CONFIRMATION_DOCUMENT(params));
    if (!isError) {
      const pdf = convertToPdf(result);
      window.open(URL.createObjectURL(pdf));
    }
    setLoading(false);
  };

  const getConfirmationTickets = async () => {
    setLoading(true);
    const params = {
      facilityIds: `0,${facilityIds}`,
      billKey: billKey,
    };
    const { result, isError } = await get(GET_CONFIRMATION_TICKETS(params));
    if (!isError) {
      const pdf = convertToPdf(result);
      window.open(URL.createObjectURL(pdf));
    }
    setLoading(false);
  };

  return {
    billKey,
    loading,
    confirmationData,
    getConfirmationDocument,
    getConfirmationTickets,
    facilityIds,
  };
}
